import { render } from "./AddReabonnement.vue?vue&type=template&id=220c9743&ts=true"
import script from "./AddReabonnement.vue?vue&type=script&lang=ts"
export * from "./AddReabonnement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__